export default (obj, data) => {
  for (let key in obj) {
    data[key] !== undefined
      ? (obj[key] = data[key])
      : typeof obj[key] === "number" || obj[key] === null
      ? (obj[key] = null)
      : obj[key] instanceof Array || obj[key] === []
      ? (obj[key] = [])
      : (obj[key] = "");
  }
};
